<template>
    <div class="pdf_main">
        <main>
            <div class="main_header">
                <div class="header-left">
                    <div class="left-1">
                        <span>{{ dataDetail.full_name && dataDetail.full_name.toUpperCase() }}</span>
                        <span>{{ dataDetail.address && dataDetail.address.toUpperCase() }}</span>
                        <!-- <span>&lt;SALUTATION&gt;&lt;FULL NAME&gt;</span>
                        <span>CUSTOMER ADDRESS #1</span>
                        <span>CUSTOMER ADDRESS #2</span>
                        <span>COUNTRY POSTAL CODE</span> -->
                    </div>
                    <!-- <div class="left-2">(Beth account number)</div> -->
                    <div class="left-3">
                        <span class="left-3-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text11') }}</span>
                        <!-- <span>{{ lang_en.pdf.text11 }} {{ dataDetail.annual_fee_end_time | current_date }}</span> -->
                        <span>{{ lang_en.pdf.text11 }} {{ dataDetail.expire_date }}</span>
                    </div>
                </div>
                <div class="header-right">
                    <div class="table">
                        <div class="table-header">
                            <span class="table-header-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text3') }}</span>
                            <span>{{ lang_en.pdf.text3 }}</span>
                        </div>
                        <div class="table-item">
                            <div class="item-left">
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text4') }}</span>
                                <span>{{ lang_en.pdf.text4 }}</span>
                            </div>
                            <div class="item-right">{{ d }} {{ m | current_month}} {{ y }}</div>
                        </div>
                        <div class="table-item outfit">
                            <div class="item-left">
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text5') }}</span>
                                <span>{{ lang_en.pdf.text5 }}</span>
                            </div>
                            <div class="item-right">USD 50,000.00</div>
                        </div>
                        <div class="table-item">
                            <div class="item-left">
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text6') }}</span>
                                <span>{{ lang_en.pdf.text6 }}</span>
                            </div>
                            <div class="item-right">USD {{ dataDetail.open_balance }}</div>
                        </div>
                        <div class="table-item outfit">
                            <div class="item-left">
                                <span class="item-left-unit">+</span>
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text7') }}</span>
                                <span>{{ lang_en.pdf.text7 }}</span>
                            </div>
                            <div class="item-right">USD {{ dataDetail.deposit_amount }}</div>
                        </div>
                        <div class="table-item outfit">
                            <div class="item-left">
                                <span class="item-left-unit">-</span>
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text8') }}</span>
                                <span>{{ lang_en.pdf.text8 }}</span>
                            </div>
                            <div class="item-right">USD {{ dataDetail.withdraw_amount }}</div>
                        </div>
                        <div class="table-item outfit">
                            <div class="item-left">
                                <span class="item-left-unit">-</span>
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text9') }}</span>
                                <span>{{ lang_en.pdf.text9 }}</span>
                            </div>
                            <div class="item-right">USD {{ dataDetail.fee_amount }}</div>
                        </div>
                        <div class="table-item">
                            <div class="item-left">
                                <span class="item-left-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text10') }}</span>
                                <span>{{ lang_en.pdf.text10 }}</span>
                            </div>
                            <div class="item-right">USD {{ dataDetail.close_balance }}</div>
                        </div>
                        <div class="table-footer">
                            <p v-if="v_lan == 'ch'">{{ $t('pdf.text13') }}</p>
                            <p>{{ lang_en.pdf.text13 }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-table">
                <div class="table">
                    <div class="table-header">
                        <div>
                            <span class="table-header-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text14') }}</span>
                            <span>{{ lang_en.pdf.text14 }}</span>
                            <span class="table-header-number">{{ number | format_card_numb }}</span>
                        </div>
                        <div>
                            <span>USD</span>
                        </div>
                    </div>
                    <table>
                        <tr class="tr tr-header">
                            <th>
                                <div class="th left-th time">
                                    <span class="th-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text15') }}</span>
                                    <span>{{ lang_en.pdf.text15 }}</span>
                                </div>
                            </th>
                            <th>
                                <div class="th left-th description">
                                    <span class="th-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text16') }}</span>
                                    <span>{{ lang_en.pdf.text16 }}</span>
                                </div>
                            </th>
                            <th>
                                <div class="th rigth-th">
                                    <span class="th-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text17') }}</span>
                                    <span>{{ lang_en.pdf.text17 }}</span>
                                </div>
                            </th>
                            <th>
                                <div class="th rigth-th balance">
                                    <span class="th-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text18') }}</span>
                                    <span>{{ lang_en.pdf.text18 }}</span>
                                </div>
                            </th>
                        </tr>
                        <tr class="tr body" v-for="(item, index) in dataDetail.list" :key="index">
                            <td>
                                <div class="left-th time">{{ item.date }}</div>
                            </td>
                            <td>
                                <div class="left-th description">{{ item.description | current_description(v_lan) }}</div>
                            </td>
                            <td>
                                <div class="rigth-th">{{ item.base_amount }}</div>
                            </td>
                            <td>
                                <div class="rigth-th balance">{{ item.balance }}</div>
                            </td>
                        </tr>
                    </table>
                    <div class="table-footer">
                        <div>
                            <span class="table-header-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text19') }}</span>
                            <span>{{ lang_en.pdf.text19 }}</span>
                        </div>
                        <div class="footer-right">
                            <span>{{ total }}</span>
                        </div>
                    </div>
                </div>
                <div class="des-1">
                    <div class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text20') }}</div>
                    <div class="outfit">{{ lang_en.pdf.text20 }}</div>
                </div>
                <div class="notices"><span v-if="v_lan == 'ch'">{{ $t('pdf.text21') }}</span><span>{{ lang_en.pdf.text21 }}</span></div>
                <div class="notices-item">
                    <div class="notices-item-label"><span v-if="v_lan == 'ch'" class="main-ch">{{ $t('pdf.text22') }}</span><span>{{ lang_en.pdf.text22 }}</span></div>
                    <div class="notices-item-des">
                        <div class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text23') }}</div>
                        <div class="outfit">{{ lang_en.pdf.text23 }}</div>
                    </div>
                </div>
                <div class="notices-item">
                    <div class="notices-item-label"><span v-if="v_lan == 'ch'" class="main-ch">{{ $t('pdf.text24') }}</span><span>{{ lang_en.pdf.text24 }}</span></div>
                    <div class="notices-item-des">
                        <div class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text25') }}</div>
                        <div class="outfit">{{ lang_en.pdf.text25 }}</div>
                    </div>
                </div>
            </div>
            <div class="main-2">
                <div class="button"><span v-if="v_lan == 'ch'">{{ $t('pdf.text26') }}</span><span>{{ lang_en.pdf.text26 }}</span></div>
                <div class="main-2-item">
                    <div class="main-2-item-des">
                        <div class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text27') }}</div>
                        <div class="outfit">{{ lang_en.pdf.text27 }}</div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-title"><span class="main-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text28') }}</span><span>{{ lang_en.pdf.text28 }}</span></div>
                    <div class="main-2-item-des">
                        <div class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text29') }}</div>
                        <div class="outfit">{{ lang_en.pdf.text29 }}</div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-title"><span class="main-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text30') }}</span><span>{{ lang_en.pdf.text30 }}</span></div>
                    <div class="main-2-item-des">
                        <div class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text31') }}</div>
                        <div class="outfit">{{ lang_en.pdf.text31 }}</div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-title"><span class="main-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text32') }}</span><span>{{ lang_en.pdf.text32 }}</span></div>
                    <div class="main-2-item-des">
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text33') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text33 }}</span>
                            </div>
                            <div class="des-item-right">3%</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text34') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text34 }}</span>
                            </div>
                            <div class="des-item-right">USD 0.20</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text35') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text35 }}</span>
                            </div>
                            <div class="des-item-right">USD 3.50 + 1.2%</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text36') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text36 }}</span>
                            </div>
                            <div class="des-item-right">USD 1.00</div>
                        </div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-title"><span class="main-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text37') }}</span><span>{{ lang_en.pdf.text37 }}</span></div>
                    <div class="main-2-item-des">
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text38') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text38 }}</span>
                            </div>
                            <div class="des-item-right">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text39') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text39 }}</span>
                            </div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text40') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text40 }}</span>
                            </div>
                            <div class="des-item-right">USD 0</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text41') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text41 }}</span>
                            </div>
                            <div class="des-item-right">USD 5,000</div>
                        </div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-label">
                        <span class="main-ch outfit">POS</span>
                        <span class="outfit" v-if="v_lan == 'ch'">消费</span>
                    </div>
                    <div class="main-2-item-des">
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text42') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text42 }}</span>
                            </div>
                            <div class="des-item-right">20</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text43') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text43 }}</span>
                            </div>
                            <div class="des-item-right">200</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text44') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text44 }}</span>
                            </div>
                            <div class="des-item-right">USD 20,000</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text45') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text45 }}</span>
                            </div>
                            <div class="des-item-right">USD 30,000</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text46') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text46 }}</span>
                            </div>
                            <div class="des-item-right">USD 100,000</div>
                        </div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-label">
                        <span class="main-ch outfit">ATM</span>
                        <span class="outfit" v-if="v_lan == 'ch'">提现</span>
                    </div>
                    <div class="main-2-item-des">
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text47') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text47 }}</span>
                            </div>
                            <div class="des-item-right">5</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text48') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text48 }}</span>
                            </div>
                            <div class="des-item-right">20</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text49') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text49 }}</span>
                            </div>
                            <div class="des-item-right">USD 20,000</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text50') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text50 }}</span>
                            </div>
                            <div class="des-item-right">USD 20,000</div>
                        </div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-title"><span class="main-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text51') }}</span><span>{{ lang_en.pdf.text51 }}</span></div>
                    <div class="main-2-item-des">
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text52') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text52 }}</span>
                            </div>
                            <div class="des-item-right" v-if="!showNew">USDC/USDT 95.96</div>
                            <div class="des-item-right" v-if="showNew">USDC/USDT 95.00</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text53') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text53 }}</span>
                            </div>
                            <div class="des-item-right">USDC/USDT 0</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text54') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text54 }}</span>
                            </div>
                            <div class="des-item-right">USDC/USDT 50</div>
                        </div>
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="main-ch outfit" v-if="v_lan == 'ch'">{{ $t('pdf.text55') }}</span>
                                <span class="outfit">{{ lang_en.pdf.text55 }}</span>
                            </div>
                            <div class="des-item-right">USDC/USDT 0</div>
                        </div>
                    </div>
                </div>
                <div class="main-2-item">
                    <div class="main-2-item-title"><span class="main-ch" v-if="v_lan == 'ch'">{{ $t('pdf.text56') }}</span><span>{{ lang_en.pdf.text56 }}</span></div>
                    <div class="main-2-item-des">
                        <div class="des-item">
                            <div class="des-item-left">
                                <span class="outfit">FEB VISA Debit</span>
                            </div>
                            <div class="des-item-right" v-if="!showNew">USDC/USDT 121.21</div>
                            <div class="des-item-right" v-if="showNew">USDC/USDT 120.00</div>
                        </div>
                    </div>
                </div>
                <div class="main-footer">
                    <div class="outfit" v-if="v_lan">{{ $t('pdf.text57') }}</div>
                    <div class="outfit">{{ lang_en.pdf.text57 }}</div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import lang_en from '@/language/en';
import moment from 'moment'

export default {
    filters: {
        current_date(v) {
            return moment(v).format('DD/MM/YYYY') || '-';
        },
        current_month(v) {
            let en_mon_arr = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Spt",
                "Oct",
                "Nov",
                "Dec",
            ];
            return en_mon_arr[v - 1];
        },
        format_card_numb(v) {
            let str = '';
            if (v) {
                str = v.replace(/\s/g, '').replace(/(.{4})/g, '$1 ');
            }
            return str;
        },
        current_description(v, v_lan) {
            if (/LOAD_CARD/.test(v)) {
                if (v_lan == 'ch') {
                    return '充值';
                } else {
                    return 'TOP-UP';
                }
            } else if (/COMPRAS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款消费';
                } else {
                    return 'DR PURCHASES';
                }
            } else if (/RETIROS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款';
                } else {
                    return 'DR WITHDRAWALS';
                }
            } else if (/RETIRO DE EFECTIVO/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款提现';
                } else {
                    return 'DR CASH WITHDRAWAL';
                }
            } else if (/SEGUROS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款保险';
                } else {
                    return 'DR INSURANCE';
                }
            } else if (/PAGOS/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款支付';
                } else {
                    return 'DR PAYMENTS';
                }
            } else if (/FUNDS "CLAWBACK"/.test(v) || /EXCESS LOAD/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款补扣';
                } else {
                    return 'DR TOP-UP REVERSAL';
                }
            } else if (/REVERSION DE DEVOLUCION/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款撤销';
                } else {
                    return 'DR RETURN REVERSAL';
                }
            } else if (/LOCAL TAX/.test(v) || /COBRO DE ITBMS/.test(v)) {
                if (v_lan == 'ch') {
                    return '税务费用';
                } else {
                    return 'FEE TAX';
                }
            } else if (/COMISION COMPRA POS\/ONLINE/.test(v)) {
                if (v_lan == 'ch') {
                    return '固定费用';
                } else {
                    return 'FEE FLAT';
                }
            } else if (/COMISIÓN TRANS\. INT\. % Aut\./.test(v)) {
                if (v_lan == 'ch') {
                    return '汇率% 费用';
                } else {
                    return 'FEE FX%';
                }
            } else if (/COMISION RETIRO ATM/.test(v)) {
                if (v_lan == 'ch') {
                    return '取款机固定费用';
                } else {
                    return 'FEE ATMF';
                }
            } else if (/COMISION % RETIRO ATM/.test(v)) {
                if (v_lan == 'ch') {
                    return '取款机% 费用';
                } else {
                    return 'FEE ATM%';
                }
            } else if (/COMISION RETIRO DE EFECTIVO/.test(v)) {
                if (v_lan == 'ch') {
                    return '提现费用';
                } else {
                    return 'FEE CASH WITHDRAWAL';
                }
            } else if (/CARGO POR EMISION DE PIN/.test(v)) {
                if (v_lan == 'ch') {
                    return '密码发行费用';
                } else {
                    return 'FEE PIN ISSUANCE';
                }
            } else if (/CARGO POR INVESTIGACION RECLAMOS/.test(v)) {
                if (v_lan == 'ch') {
                    return '调查费用';
                } else {
                    return 'FEE CLAIMS INVESTIGATION';
                }
            } else if (/MEMBRESIA TARJETA ADICIONAL/.test(v)) {
                if (v_lan == 'ch') {
                    return '会员+ 费用';
                } else {
                    return 'FEE ADDTL CARD MEMBERSHIP';
                }
            } else if (/MEMBRESIA TARJETA TITULAR/.test(v)) {
                if (v_lan == 'ch') {
                    return '会员费用';
                } else {
                    return 'FEE CARD MEMBERSHIP';
                }
            } else if (/RENOVACION ANUAL TARJETA ADICIONAL/.test(v)) {
                if (v_lan == 'ch') {
                    return '年费+ 费用';
                } else {
                    return 'FEE ADDTL CARD ANNUAL RENEWAL';
                }
            } else if (/RENOVACION ANUAL TARJETA TITULAR/.test(v)) {
                if (v_lan == 'ch') {
                    return '年费 费用';
                } else {
                    return 'FEE CARD ANNUAL RENEWAL';
                }
            } else if (/CARGO POR REPOSICION DE TARJETA/.test(v)) {
                if (v_lan == 'ch') {
                    return '费用';
                } else {
                    return 'FEE CARD REPLACE';
                }
            } else if (/DEVOLUCION DE COMPRAS/.test(v)) {
                if (v_lan == 'ch') {
                    return '消费退款存入';
                } else {
                    return 'CR PURCHASE RETURNS';
                }
            } else if (/REVERSION DE COMPRA/.test(v)) {
                if (v_lan == 'ch') {
                    return '消费撤销存入';
                } else {
                    return 'CR PURCHASE REVERSAL';
                }
            } else if (/REVERSION DE PAGO/.test(v)) {
                if (v_lan == 'ch') {
                    return '支付撤销存入';
                } else {
                    return 'CR PAYMENT REVERSAL';
                }
            } else if (/REVERSION DE RETIRO/.test(v)) {
                if (v_lan == 'ch') {
                    return '提款撤销存入';
                } else {
                    return 'CR WITHDRAWAL REVERSAL';
                }
            } else if (/AJUSTE POR RECLAMOS RETIROS/.test(v)) {
                if (v_lan == 'ch') {
                    return '理赔调整';
                } else {
                    return 'CLAIMS ADJ';
                }
            } else {
                return v;
            }
        },
    },
    props: {
        dataDetail: {
            default: {}
        },
        y: {
            default: ''
        },
        m: {
            default: ''
        },
        d: {
            default: ''
        },
        total: {
            default: 0
        },
        number: {
            default: ''
        },
    },
    data() {
        return {
            lang_en: lang_en,
            showNew: false,
        }
    },
    mounted() {
        const that = this;
        // const time = new Date();
        // const year = time.getFullYear();
        // const month = time.getMonth() + 1;
        if (that.y < 2023 || (that.y == 2023 && that.m < 4 && that.d < 4)) {
            that.showNew = false;
        } else {
            that.showNew = true;
        }
    }
}
</script>
<style scoped>
.pdf_main {
    font-size: 14px;
    /*    width: 595.28 * 2;*/
    /*	width: 1190.56px;*/
    margin: 0 30px 10px 30px;
    padding-bottom: 20px;
}

main {
    margin-top: 20px;
}

main .main_header {
    display: flex;

}

.header-left {
    width: 50%;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.header-left span {
    font-family: Outfit;
    font-size: 12px;
    font-weight: 300;
    color: #363636;
}

.header-left .left-1 {
    display: flex;
    flex-direction: column;
}

.left-2 {
    margin-top: 24px;
    font-family: Outfit;
    font-size: 12px;
    font-weight: 300;
    color: #363636;
}

.left-3 {
    margin-top: 24px;
}

.left-3 .left-3-ch {
    margin-right: 4px;
}

.header-right {
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.header-right .table {
    width: 340px;
}

.header-right .table .table-header {
    background-color: #000000;
    color: #FFFFFF;
    text-align: left;
    border-radius: 8px 8px 0 0;
    padding-left: 6px;
    padding-top: 4px;
    padding-bottom: 4px;
}

.header-right .table .table-item {
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 6px;
    padding-right: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #bababa;
}

.header-right .table-item .item-left .item-left-ch {
    margin-right: 6px;
}

.header-right .table-item .item-left span,
.header-right .table-item .item-right {
    font-weight: 500;
}

.header-right .table-item.outfit .item-left span,
.header-right .table-item.outfit .item-right {
    font-family: Outfit;
    font-weight: 300;
}

.header-right .table-item .item-left .item-left-unit {
    margin-left: 8px;
    margin-right: 4px;
    font-family: Outfit;
    font-weight: 300;
}

.header-right .table .table-footer {
    height: 50px;
}

.header-right .table .table-footer p {
    margin-top: 4px;
    font-size: 12px;
    padding-left: 6px;
    font-family: Outfit;
    font-weight: 300;
    color: #363636;
}

.main-table {
    margin-top: 8px;
}

.main-table .table {
    width: 100%;
    border-collapse: collapse;
}

.main-table .table .table-header {
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 8px 8px 0 0;
    background-color: #30CD9B;
    color: #FFFFFF;
    font-family: Outfit;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table-header-ch {
    margin-right: 4px;
}

.main-table .table .table-header .table-header-number {
    margin-left: 8px;
}

.main-table .table table {
    width: 100%;
}

.main-table .table table .tr-header {
    border-bottom: 1px solid #d3d3d3;
}

.main-table .table table .tr th {
    padding: 4px 0;
}

.main-table .table table .tr .left-th {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.main-table .table table .tr .rigth-th {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.main-table .table table tr .time {
    width: 90px;
}

.main-table .table table tr .description {
    width: 550px;
}

.main-table .table table tr .balance {
    width: 120px;
}

.main-table table .body td {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 0;
    padding-right: 0;
}

.main-table table .body td div {
    font-family: Outfit;
    font-weight: 300;
}

.main-table .table .table-footer {
    margin-top: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 0 0 8px 8px;
    background-color: #30CD9B;
    color: #FFFFFF;
    font-family: Outfit;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.main-table .table .table-footer .footer-right {
    margin-right: 120px;
}

.main-table .des-1 {
    margin-top: 8px;
    padding-left: 6px;
    padding-right: 6px;
}

.main-table .des-1 .outfit {
    font-family: Outfit;
    font-weight: 300;
    font-size: 12px;
}

.main-table .notices {
    margin-top: 36px;
    margin-bottom: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #47D7AC;
    border-radius: 8px;
    padding: 4px 0;
    font-size: 16px;
}

.main-table .notices-item {
    padding-left: 6px;
    margin-bottom: 12px;
}

.main-table .notices-item .notices-item-label {
    font-family: Outfit;
    font-size: 12px;
    color: #00C389;
}

.main-table .notices-item .notices-item-des {
    margin-top: 4px;
}

.main-table .notices-item .notices-item-des div {
    font-family: Outfit;
    font-size: 12px;
    font-weight: 300;
}

.outfit {
    font-family: Outfit;
    font-weight: 300;
}

.main-ch {
    margin-right: 4px;
}

.main-2 {
    margin-top: 8px;
}

.main-2 .button {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #47D7AC;
    border-radius: 8px;
    padding: 4px 0;
    font-size: 16px;
}

.main-2 .main-2-item {
    padding-left: 6px;
    margin-bottom: 24px;
}

.main-2 .main-2-item .main-2-item-des div {
    font-family: Outfit;
    font-size: 12px;
    font-weight: 300;
}

.main-2 .main-2-item .main-2-item-des .des-item {
    display: flex;
}

.main-2 .main-2-item .main-2-item-des .des-item .des-item-left {
    width: 400px;
    text-align: left;
}

.main-2 .main-footer {
    margin-top: 60px;
}
</style>